import React, { useState } from 'react';
import { api } from '../services/api';

export default function AdminBilling() {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [done, setDone]       = useState(false);

  const download = async () => {
    setLoading(true); setError(''); setDone(false);
    try {
      await api.adminDownloadTaxCSV();
      setDone(true);
      setTimeout(() => setDone(false), 3000);
    } catch (err) {
      setError(err.message || 'Export failed');
    } finally {
      setLoading(false);
    }
  };

  const year = new Date().getFullYear();

  return (
    <div>
      <h1 style={s.h1}>Billing</h1>
      <p style={s.sub}>Manage subscription billing and export financial data.</p>

      {/* Tax export */}
      <div style={s.card}>
        <div style={s.cardTitle}>BTW / Tax export</div>
        <p style={s.hint}>
          Download a CSV with all subscription revenue, BTW (21%) calculations, and a quarterly breakdown
          ready for your BTW aangifte. Opens directly in Google Sheets or Excel.
        </p>

        <div style={s.exportRow}>
          <div style={s.exportMeta}>
            <div style={s.exportIcon}>📊</div>
            <div>
              <div style={s.exportName}>seva-btw-export-{year}.csv</div>
              <div style={s.exportDesc}>Restaurant overview · Quarterly BTW summary · Year totals</div>
            </div>
          </div>
          <button style={{ ...s.dlBtn, ...(loading ? s.dlBtnDisabled : {}) }} onClick={download} disabled={loading}>
            {loading ? 'Generating…' : done ? '✓ Downloaded' : '↓ Download CSV'}
          </button>
        </div>

        {error && <div style={s.err}>{error}</div>}

        <div style={s.noteBox}>
          <div style={s.noteRow}>
            <span style={s.noteDot} />
            Figures are estimates based on monthly subscription prices — exact once Mollie is connected.
          </div>
          <div style={s.noteRow}>
            <span style={s.noteDot} />
            Inactive restaurants with unknown deactivation dates are flagged "Check manually".
          </div>
          <div style={s.noteRow}>
            <span style={s.noteDot} />
            BTW rate applied: 21% (standard rate for digital services in the Netherlands).
          </div>
        </div>
      </div>

      {/* Mollie coming soon */}
      <div style={{ ...s.card, textAlign: 'center', padding: '40px 32px' }}>
        <div style={{ fontSize: 32, marginBottom: 14 }}>💳</div>
        <h2 style={{ fontSize: 17, fontWeight: 800, color: '#0f172a', margin: '0 0 8px' }}>Automated invoicing — coming soon</h2>
        <p style={{ fontSize: 14, color: '#64748b', margin: 0, lineHeight: 1.6, maxWidth: 360, marginLeft: 'auto', marginRight: 'auto' }}>
          Mollie integration will handle iDEAL, card, and SEPA payments with automatic invoicing,
          account activation, and exact payment records in the tax export.
        </p>
      </div>
    </div>
  );
}

const s = {
  h1:   { fontSize: 28, fontWeight: 800, color: '#0f172a', margin: 0, letterSpacing: '-0.5px' },
  sub:  { fontSize: 14, color: '#64748b', marginTop: 4, marginBottom: 24 },

  card: {
    background: '#fff', border: '1px solid #e2e8f0', borderRadius: 20,
    padding: '22px 26px', marginBottom: 16, boxShadow: '0 1px 4px rgba(15,23,42,0.06)',
  },
  cardTitle: {
    fontSize: 11, fontWeight: 700, color: '#94a3b8',
    textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 10,
  },
  hint: { fontSize: 13, color: '#64748b', margin: '0 0 20px', lineHeight: 1.6 },

  exportRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, marginBottom: 20 },
  exportMeta:{ display: 'flex', alignItems: 'center', gap: 14 },
  exportIcon:{ fontSize: 28 },
  exportName:{ fontSize: 14, fontWeight: 700, color: '#0f172a' },
  exportDesc:{ fontSize: 12, color: '#94a3b8', marginTop: 2 },

  dlBtn: {
    background: '#4f46e5', border: 'none', borderRadius: 10,
    padding: '10px 22px', fontSize: 13, fontWeight: 700, color: '#fff',
    cursor: 'pointer', flexShrink: 0, whiteSpace: 'nowrap',
  },
  dlBtnDisabled: { background: '#a5b4fc', cursor: 'not-allowed' },

  err: {
    background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca',
    borderRadius: 8, padding: '10px 14px', fontSize: 13, marginTop: 8,
  },

  noteBox: {
    background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10,
    padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 8,
  },
  noteRow:  { display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 12, color: '#64748b', lineHeight: 1.5 },
  noteDot:  { width: 5, height: 5, borderRadius: '50%', background: '#94a3b8', flexShrink: 0, marginTop: 5 },
};
